import { Navigate } from "react-router";
import AppShell from "./layouts/AppShell";
import Dashboard from "./views/Dashboard";
import DsAppsView from "./views/DsApps";
import TemplatesView from "./views/Templates";
import ThirdPartyContractsView from "./views/ThirdPartyContracts";
import DeploymentsView from "./views/Deployments";
import CreateDeploymentView from "./views/CreateDeployment";
import DeploymentLogsView from "./views/DeploymentLogs";
import { BASE_PATH } from "./routePaths";

export const routes = [
  {
    path: "/",
    element: <Navigate to={BASE_PATH} replace />,
  },
  {
    path: BASE_PATH,
    element: <AppShell />,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "ds-apps", element: <DsAppsView /> },
      { path: "templates", element: <TemplatesView /> },
      { path: "third-party-contracts", element: <ThirdPartyContractsView /> },
      { path: "deployments", element: <DeploymentsView /> },
      { path: "deployments/create", element: <CreateDeploymentView /> },
      { path: "deployments/:id/logs", element: <DeploymentLogsView /> },
    ],
  },
];
